// https://fluentsite.z22.web.core.windows.net/quick-start
import {
  FluentProvider,
  teamsLightTheme,
  teamsDarkTheme,
  teamsHighContrastTheme,
  Spinner,
  tokens,
} from "@fluentui/react-components";

import { HashRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import {app} from "@microsoft/teams-js";
import Tab from "./Tab";
import { TeamsFxContext } from "./Context";
import config from "../helper/config";

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
  const {loading, theme, themeString, teamsUserCredential} = useTeamsUserCredential({
      initiateLoginEndpoint: config.initiateLoginEndpoint!,
      clientId: config.clientId!,
  });

  app.initialize().then(() => {
      //notify success so teams know to clear out the "loading" spinners
      app.notifySuccess();
  });


  return (
    <TeamsFxContext.Provider value={{ theme, themeString, teamsUserCredential }}>
        <FluentProvider
            theme={
                themeString === "dark"
                    ? teamsDarkTheme
                    : themeString === "contrast"
                        ? teamsHighContrastTheme
                        : {
                            ...teamsLightTheme,
                            colorNeutralBackground3: "#eeeeee",
                        }
            }
            style={{background: tokens.colorNeutralBackground3}}
        >
            <div className="bootstrap-wrapper">
                <div className="container-fluid" style={{paddingTop: "16px"}}>
                    <Router>
                        {loading ? (
                            <Spinner style={{margin: 100}}/>
                        ) : (
                            <Routes>
                                <Route path="/tab" element={<Tab />}/>
                                <Route path="*" element={<Navigate to={"/tab"}/>}></Route>
                            </Routes>
                        )}
                    </Router>
                </div>
            </div>
        </FluentProvider>
    </TeamsFxContext.Provider>
);

}
